import { Target, TrendingUp, Clock, TrendingDown, BarChart3 } from 'lucide-react';

export default function TrackRecord() {
  return (
    <section className="section" id="track">
      <div className="wrap">
        <div className="sec-tag"><Target size={13} />Track Record</div>
        <h2>Public. Permanent.<br /><em>No cherry-picking.</em></h2>

        <div className="track-layout">
          <div>
            <div className="track-quote">
              "Every projection published, every outcome recorded.
              <strong> The misses matter as much as the hits.</strong>&nbsp;
              We explain both."
            </div>
            <div className="track-cite">Market Intelligence Grid, Methodology</div>
            <p style={{ marginTop: 24, fontSize: 'var(--t-base)', color: 'var(--ink2)', lineHeight: 1.75 }}>
              Forecast accountability is a core feature, not a footnote. Every daily report opens with
              yesterday's projection outcome — Hit, Beat, or Miss — with the exact cause attributed to
              a specific agent or signal.
            </p>
          </div>

          <div className="track-grid">
            {[
              { cls: 'tc-hit',  icon: Target,      lbl: 'tl-hit',  label: 'HIT',     num: '61%', sub: 'Within projection range' },
              { cls: 'tc-beat', icon: TrendingUp,  lbl: 'tl-beat', label: 'BEAT',    num: '11%', sub: 'Exceeded bull range' },
              { cls: 'tc-miss', icon: TrendingDown,lbl: 'tl-miss', label: 'MISS',    num: '22%', sub: 'Outside range' },
              { cls: 'tc-pend', icon: Clock,       lbl: 'tl-pend', label: 'PENDING', num: '6%',  sub: 'Current period open' },
            ].map(r => (
              <div key={r.label} className="track-cell">
                <div className={`tc-icon ${r.cls}`}><r.icon size={26} /></div>
                <div className={`tc-lbl ${r.lbl}`}>{r.label}</div>
                <span className="tc-num">{r.num}</span>
                <div className="tc-sub">{r.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
